import ScrollingText from '@pixelunion/scrolling-text';

export default class DynamicScrollingText {
  constructor(section) {
    this.el = section.el;
    new ScrollingText(this.el);
  }
}
